import React from 'react';
import './BookingCalendar.scss';

function MonthLine({ label, stats }) {
  const total = stats?.total || 0;
  const paid = stats?.paid || 0;
  const waiting = stats?.waiting || 0;

  return (
    <div className="booking-cal__month-line">
      <span className="booking-cal__month-line-label">{label}</span>
      <span className="booking-cal__month-line-total">{total}</span>
      {total > 0 && (
        <span className="booking-cal__month-line-detail">
          {paid} paid{waiting > 0 ? ` · ${waiting} waiting` : ''}
        </span>
      )}
    </div>
  );
}

/**
 * Year-at-a-glance month grid (same pattern as Booking Calendar).
 * bookingType: "group" | "private" — shows counts for that booking type only.
 */
export default function AdminBookingMonthGrid({
  summary,
  year,
  onYearChange,
  selectedMonth,
  onMonthSelect,
  bookingType = 'group',
}) {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-end mb-3">
        <div className="booking-cal__year-nav">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onYearChange(year - 1)}
            aria-label="Previous year"
          >
            ‹
          </button>
          <span className="booking-cal__year-label">{year}</span>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onYearChange(year + 1)}
            aria-label="Next year"
          >
            ›
          </button>
        </div>
      </div>

      {summary && (
        <div className="booking-cal__grid" role="list">
          {summary.months.map((m) => {
            const isSelected = selectedMonth === m.month;
            const isCurrentMonth = year === currentYear && m.month === new Date().getMonth() + 1;
            const stats = bookingType === 'private' ? m.private : m.group;
            const waiting = stats?.waiting || 0;

            return (
              <button
                key={m.year_month}
                type="button"
                role="listitem"
                className={`booking-cal__cell${isSelected ? ' booking-cal__cell--selected' : ''}${isCurrentMonth ? ' booking-cal__cell--current' : ''}`}
                onClick={() => onMonthSelect(m.month === selectedMonth ? null : m.month)}
                aria-pressed={isSelected}
              >
                <span className="booking-cal__cell-label">{m.label}</span>
                <MonthLine
                  label={bookingType === 'private' ? 'Private' : 'Group'}
                  stats={stats}
                />
                {waiting > 0 && (
                  <span className="booking-cal__cell-attention">{waiting} waiting</span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}
